import { Button, Divider, IconButton, InputLabel,TextField } from "@mui/material";
import MenuButton from "elements/MenuButton";
import { useEffect, useState } from "react";
import shippo_logo from "assets/img/shippo_logo.png";
import { ApiRequest } from "GlobalFunctions";
import ISwitch from "elements/ISwitch";


const defaultShippoData = {
    enabled: false,
    linked: true,
}

export default function Shippo(props: any) {
    const { setLoading } = props;
    const [popupWindow, setPopupWindow] = useState<Window | null>(null);
    const [popupCheckInterval, setPopupCheckInterval] = useState<NodeJS.Timeout | null>(null);
    const [shippoData, setShippoData] = useState<any>(defaultShippoData);

    useEffect(() => {
        setLoading(false);
    }, [setLoading]);

    const checkShippoStatus = async () => {
        
        await ApiRequest({
            method: 'GET',
            url: '/shippo/checkStatus',
            query: { 
                store_id: localStorage.getItem('store_id')
            },
            setResponse: (response: any) => {
                setShippoData(response);
            }
          })
    }

    useEffect(() => {
        checkShippoStatus();
    }, []);

    const openOAuthPopup = () => {
        // Calculate centered position for the popup
        const width = 800;
        const height = 600;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2;
        const store_id = localStorage.getItem('store_id');
        // Open the OAuth URL in a popup
        const popup = window.open(
            `https://goshippo.com/oauth/authorize?response_type=code&client_id=45573f3025f54483968002ad5bc580ec&scope=*&state=shippo-${store_id}`, 
            "ShippoOAuth", 
            `width=${width},height=${height},left=${left},top=${top}`
        );
        
        setPopupWindow(popup);
        
        // Set up interval to check if popup is closed
        const checkInterval = setInterval(() => {
            if (popup && popup.closed) {
                clearInterval(checkInterval);
                setPopupCheckInterval(null);
                setPopupWindow(null);

                // Check the Shippo status again after the popup is closed
                checkShippoStatus();
            }
        }, 500);
        
        setPopupCheckInterval(checkInterval);
    };

    // Clean up interval when component unmounts
    useEffect(() => {
        return () => {
            if (popupCheckInterval) {
                clearInterval(popupCheckInterval);
            }
        };
    }, [popupCheckInterval]);

    /*==========================
    UPDATE SHIPPO STATUS
    ==========================*/
    const updateShippoStatus = async (event: any) => {
        const newStatus = event.target.checked;
        setShippoData((prevState: any) => ({
            ...prevState,
            enabled: newStatus
        }));

        await ApiRequest({
            method: 'POST',
            url: '/shippo/updateStatus',
            body: { 
                store_id: localStorage.getItem('store_id'),
                status: newStatus
            },
            setResponse: (response: any) => {
                // Handle response if needed
            }
          })
    }

    /*==========================
    DISCONNECT SHIPPO ACCOUNT
    ==========================*/
    const disconnectShippo = async () => {
        await ApiRequest({
            method: 'POST',
            url: '/shippo/disconnect',
            body: { 
                store_id: localStorage.getItem('store_id')
            },
            setResponse: (response: any) => {
                checkShippoStatus();
            }
        });
    }

    return (
        <div className='ModuleContainer'>
            <div className="ModuleHeader">
                <div className="ComponentTitle">
                    <h1>Integrations</h1>
                </div>

                <div className='menu_button_container'>
                    <MenuButton 
                        label={"Shipping Classes"}
                        to={"/shipping/zones"}
                    />
                    <MenuButton 
                        label={"Integrations"}
                        to={"/shipping/shippo"}
                    />
                </div>

                <div className="ModuleActions">
                    
                </div>
            </div>

            <div id="shippoContent" className='ModuleContent'>
                <div className='shippo_oauth_row'>
                    <div className='shippo_status'>
                        <img src={shippo_logo} /> 
                        {shippoData.linked ?
                            <p className={shippoData.enabled ? "shippo_status_text on" : "shippo_status_text off"}>
                                {shippoData.enabled ? "• On" : "• Off"}
                            </p>
                            :
                            <p className="shippo_status_text unlinked">
                                • Not Connected
                            </p>
                        }
                    </div>

                    {!shippoData.linked &&
                        <Button
                            variant="contained"
                            color="primary"
                            className="shippo_button"
                            onClick={openOAuthPopup}
                        >
                            Connect to Shippo
                        </Button>
                    }
                </div>  

                

                {shippoData.linked && 
                    <>
                        <Divider className="divider" />
                        <div>
                            <div className="shippo_row">
                                <span className="account_label">Enable Shippo</span>
                                <ISwitch
                                    label={shippoData.enabled ? "On" : "Off"}
                                    checked={shippoData.enabled}
                                    onChange={updateShippoStatus}
                                />
                            </div>
                            
                            <div className="shippo_row" style={{ marginTop: '20px' }}>
                                <a
                                    className="shippo_disconnect_button"
                                    onClick={disconnectShippo}
                                >
                                    Disconnect Shippo Account
                                </a>
                            </div>
                        </div>
                    </>
                }

                <Divider className="divider" />
                
            </div>

            
        </div>
    )
}
